/**
 * A global namespace for `keydown` event.
 */
const keydownEvent = 'keydown';
export default keydownEvent;
